<div class="modal-header d-flex align-items-center">
  <h5 class="h5 modal-title flex-grow-1 semibold pr-4" [ngClass]="notificationType[type]">
    {{ title }}
  </h5>
  <button type="button" class="btn btn-icon" aria-label="Close" (click)="onClose()">
    <i class="icon-close icon-16"></i>
  </button>
</div>
<div class="modal-body">
  <p class="note mb-4" [innerHTML]="description | sanitizeRichText"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light m-0" (click)="onClose()">{{ 'common.buttons.close' | translate }}</button>
</div>
